const StateUsage = (state, annArray, annualUsage, usageType) => {
  const baseValues = {
    Arizona: [656, 615, 695, 731, 1027, 1440, 1739, 1695, 1235, 771, 661, 734],
    Colorado: [1033, 957, 900, 865, 852, 974, 1206, 1277, 1187, 907, 871, 972],
    Nevada: [656, 615, 695, 731, 1027, 1440, 1739, 1695, 1235, 771, 661, 734],
    "New Jersey": [
      1080, 1147, 775, 773, 760, 1092, 1179, 1293, 1244, 871, 953, 833,
    ],
    "New Mexico": [
      1058, 941, 854, 755, 762, 995, 1298, 1405, 1295, 926, 789, 922,
    ],
    "North Carolina": [
      1147, 1080, 775, 773, 760, 1092, 1179, 1293, 1244, 871, 953, 833,
    ],
    Ohio: [970, 983, 807, 750, 709, 1083, 1375, 1476, 1359, 830, 756, 901],
    Oklahoma: [845, 781, 750, 729, 901, 1180, 1430, 1463, 1367, 1030, 767, 759],
    Oregon: [1210, 1059, 984, 896, 844, 893, 1058, 1154, 1019, 842, 911, 1129],
    "South Carolina": [
      1147, 1080, 775, 773, 760, 1092, 1179, 1293, 1244, 871, 953, 833,
    ],
    Texas: [845, 781, 750, 729, 901, 1180, 1430, 1463, 1367, 1030, 767, 759],
    Utah: [985, 873, 847, 795, 792, 965, 1319, 1513, 1279, 874, 815, 943],
    Virginia: [970, 983, 807, 750, 709, 1083, 1375, 1476, 1359, 830, 756, 901],
    Wyoming: [824, 670, 652, 595, 604, 819, 1090, 1010, 764, 645, 644, 824],
    Default: [
      1213, 1187, 1009, 910, 910, 1148, 1397, 1464, 1336, 975, 878, 1085,
    ],
  };

  // Where we figure out the partial usage...

  const total = (arr) => arr.reduce((a, b) => a + b, 0);

  // console.log(state)

  const calculateMonthlyUsage = (month, baseValue, state) => {
    if (month) {
      return month;
    }
    const baseValuesForState = baseValues[state] || baseValues.Default;
    const baseTotal = total(
      baseValuesForState.filter((val, i) => annArray[i] !== 0)
    );
    const usageTotal = total(annArray.filter((val) => val !== 0));
    const ratio = baseTotal / usageTotal;
    const partial = usageType === "Partial 12 Months" ? 1.2 : 1;
    const monthlyUsage = Math.round(baseValue / ratio) * partial;
    return monthlyUsage;
  };

  const baseValuesForState = baseValues[state] || baseValues.Default;

  const totalArray = baseValuesForState.map((baseValue, i) => {
    const month = annArray[i];
    const monthlyUsage = calculateMonthlyUsage(month, baseValue, state);
    const monthlyTotal = Math.round(monthlyUsage);
    return monthlyTotal;
  });

  const annualArray = baseValuesForState.map((baseValue) =>
    Math.round((baseValue / total(baseValuesForState)) * annualUsage)
  );

  if (annualUsage) {
    return annualArray;
  }
  return totalArray;
};

export default StateUsage;
